import React, { ReactElement } from 'react';
import { SxProps, Theme } from '@mui/material/styles';
import { useStyleEditor } from './StyleEditorContext';
import { sharedColors } from '../../../utils/Style';

type EditableChildProps = {
  onClick?: React.MouseEventHandler;
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  sx?: SxProps<Theme>;
};

type EditableStyleWrapperProps = {
  path: string;
  children: ReactElement<EditableChildProps>;
};

export const EditableStyleWrapper = ({
  path,
  children,
}: EditableStyleWrapperProps) => {
  const { openDrawer, hoveredPath, setHoveredPath, openedPath } =
    useStyleEditor();

  const childProps = children.props;
  const isHovered = hoveredPath === path;
  const isOpened = openedPath === path;

  return React.cloneElement(children, {
    onClick: (e: React.MouseEvent) => {
      e.stopPropagation();
      childProps.onClick?.(e);
      openDrawer(path);
    },
    onMouseEnter: (e: React.MouseEvent) => {
      e.stopPropagation();
      childProps.onMouseEnter?.(e);
      setHoveredPath(path);
    },
    onMouseLeave: (e: React.MouseEvent) => {
      childProps.onMouseLeave?.(e);

      if (hoveredPath === path) {
        setHoveredPath(null);
      }
    },
    sx: [
      // @ts-ignore
      childProps.sx,
      {
        cursor: 'pointer',
        outline: isOpened
          ? `2px solid ${sharedColors.blue5}`
          : isHovered
          ? `1px solid ${sharedColors.blue4}`
          : '1px solid transparent',
      },
    ],
  });
};
